import {Component} from '@angular/core';
import {RouterModule} from '@angular/router';
import {WaButtonDirective} from 'angular-awesome';
import {WaTextDirective} from 'angular-awesome';
import {WaDetailsDirective} from 'angular-awesome';
import {MarkdownComponent} from 'ngx-markdown';
@Component({
	selector:'jwebmp-comp-jquimenu',
	templateUrl:'./JQUIMenuPage.html',
	styles: [],
	styleUrls:['./JQUIMenuPage.scss'
],
	viewProviders:[],
	animations:[],
	providers:[],
	schemas:[],
	preserveWhitespaces:true,
	host:{},
	imports:[
		RouterModule,
		WaButtonDirective,
		WaTextDirective,
		WaDetailsDirective,
		MarkdownComponent,
],
	standalone:true
})
export class JQUIMenuPage
{
	mdContent_204 = `\`\`\`java
import com.jwebmp.plugins.jqueryui.menu.JQUIMenu;
\`\`\``;
	mdContent_205 = `\`\`\`java
new JQUIMenu&lt;&gt;()
\`\`\``;
	mdContent_206 = `\`\`\`java
var menu = new JQUIMenu<>();
menu.addItem("Open");
menu.addItem("Save");
menu.addItem("Close");
\`\`\``;
}
